import { injectIntl } from 'react-intl';

const GroupStrictlyNecessary = ({ intl }) => {
  if (intl.locale === 'en') {
    return (
      <>
        These cookies enable essential functionality such as security, identity
        verification and network management.{' '}
        <strong className="text-weight-semi-bold">
          These cookies cannot be disabled on our systems.
        </strong>{' '}
        Although they are necessary, you can block these cookies directly in
        your browser, but doing so may compromise your experience and impair the
        functioning of the site.
      </>
    );
  }

  return (
    <>
      Esses cookies permitem funcionalidades essenciais, tais como segurança,
      verificação de identidade e gestão de rede.{' '}
      <strong className="text-weight-semi-bold">
        Esses cookies não podem ser desativados em nossos sistemas.
      </strong>{' '}
      Embora sejam necessários, você pode bloquear esses cookies diretamente no
      seu navegador, mas isso pode comprometer sua experiência e prejudicar o
      funcionamento do site.
    </>
  );
};

export default injectIntl(GroupStrictlyNecessary);
